/**
 * this closure deals with Datastore functions
 */
const _dsIntegration = (function () {
    function DS({ ds, storage, origin, serviceURL }) {
        /**
         * creates a new user
         */
        this.createUserItem = function (callback) {
            const emailInput = document.querySelector(
                `[data-role="subscription-card-input"]`
            ).value;
            // document.querySelector(`[data-role="users-email"]`).value ||
            // document.querySelector(`[data-role="subscription-card-input"]`)
            //     .value;

            // if (!emailInput) return;

            // if (!emailInput.match(/\w+@\w+\.\w+/) || emailInput.match(/ {1,}/))
            //     return;

            const currentData = storage.get();

            const sfUser = {
                subject_finder_data: encodeURIComponent(
                    JSON.stringify(currentData)
                ),
                email: emailInput || '',
                date_modified: JSON.stringify(Date.now()),
                email_optin: false,
            };

            if (origin.match(/localhost/i)) {
                ds.collection('subject-finder-items')
                    .add(sfUser)
                    .then((data) => {
                        window.userUid = data.id;
                        if (callback) callback(data.id);
                    });

                return;
            }

            fetch(
                `https://www.otago.ac.nz/_design/integration-points/subject-finder-subject-list/add-user`,
                {
                    method: 'POST',
                    body: JSON.stringify(sfUser),
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
                .then((data) => data.json())
                .then((json) => {
                    window.userUid = json.id;

                    if (callback) callback(json.id);
                })
                .catch((err) => {
                    throw new Error(err);
                });
        };

        /**
         * updates user subject finder details
         * when going through the subject finder steps
         *
         * @return {void}
         */
        this.updateUserData = function (extraData, callback) {
            const emailInput = document.querySelector(
                `[data-role="subscription-card-input"]`
            ).value;
            // document.querySelector(`[data-role="users-email"]`).value ||
            // document.querySelector(`[data-role="subscription-card-input"]`)
            //     .value;
            const currentData = storage.get();

            if (!window.userUid) return;

            const sfData = {
                subject_finder_data: encodeURIComponent(
                    JSON.stringify(currentData)
                ),
                email: emailInput || '',
                email_optin: currentData.emailOptIn,
                date_modified: JSON.stringify(Date.now()),
                ...extraData,
            };

            if (origin.match(/localhost/i)) {
                ds.collection('subject-finder-items')
                    .doc(window.userUid)
                    .update(sfData);

                if (callback) callback();

                return;
            }

            sfData.id = window.userUid || currentData.userUid;

            fetch(
                `https://www.otago.ac.nz/_design/integration-points/subject-finder-subject-list/update-user-data`,
                {
                    method: 'POST',
                    body: JSON.stringify(sfData),
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
                .then((res) => {
                    if (callback) {
                        callback();
                    }
                })
                .catch((err) => {
                    console.log(`Issue updating user: ${err}`);
                    if (callback) callback();

                    throw new Error(err);
                });
        };

        /**
         * does a check to see if a user's email exists in DS
         *
         * @param {string} email
         * the user's email
         *
         * @param {callable} callback
         * the callback will run when the fetch either
         * fails or succeeds, if it succeeds and the
         * user is found, the user will be the first param
         * the result will be an array
         *
         * @return {void}
         */
        this.userEmailExists = function (email, callback) {
            if (!email) return;

            if (origin.match(/localhost/i)) {
                fetch(
                    `${serviceURL}/subject-finder-items?filters=document.email===${email}`
                )
                    .then((res) => res.json())
                    .then((json) => {
                        if (callback) callback(json);
                    })
                    .catch((err) => {
                        throw new Error(err);
                    });

                return;
            }

            fetch(
                `https://www.otago.ac.nz/_design/integration-points/subject-finder-subject-list/get-user-by-email?email=${email}`
            )
                .then((res) => res.json())
                .then((json) => {
                    if (callback) callback(json);
                })
                .catch((err) => {
                    throw new Error(err);
                });
        };
    } // end DS

    return (props) => {
        return new DS(props);
    };
})();

export default _dsIntegration;
